import { FC } from "react"

import { Collapse, CollapseItem } from "@hdi-seguros/web-components.collapse";

interface CollapsableSectionsProps {
    title: string;
    children: JSX.Element,
}

export const CollapsableSections: FC<CollapsableSectionsProps> = ({ title, children }) => {

    const item: Array<CollapseItem> = [
        {   
            key: title,
            label: title,
            children,
        },
    ];

    return (
        <Collapse 
            items={ item }
            style={{ marginBottom: 5 }}
        />
    )
}
